import React, { useState } from 'react';
import PortfolioPage from '../../components/PortfolioPage';
import MainImage from '../../images/portfolio/ViciousDogs/thumbnail.jpg';
import Progress_1 from '../../images/portfolio/ViciousDogs/VD_progress1.jpg';
import Progress_2 from '../../images/portfolio/ViciousDogs/VD_progress2.jpg';
import Progress_3 from '../../images/portfolio/ViciousDogs/VD_progress3.jpg';
import Progress_4 from '../../images/portfolio/ViciousDogs/VD_progress4.jpg';
import { useT } from '../../i18n';

const PortfolioCrispinGlover = () => {
    const t = useT();
    return <PortfolioPage img={MainImage} url="https://player.vimeo.com/video/558745578" title="Vicious Dogs" description={t(<p>
      “Vicious Dogs” er en bisarr film om en gutt på tur gjennom skogen, og hans møter med de forskjellige skapningene som lever der. Vi blir kastet inn i en verden som er uforutsigbar, fargerik, morsom og nådeløs. Filmen er en adapsjon av en fortelling skrevet av en 10-åring. Filmen benytter digitalt-håndanimerte, 2D-karakterer sammen med modellerte 3D-bakgrunner.
      <br />
      <br />
      I filmen følger vi Per, en bryter som er på løpetur gjennom skogen. Seeren vet aldri hva som er rundt hjørnet for protagonisten, bestående av merkelige karakterer og forskjellige miljøer for han å forholde seg til. Derfor vil filmen kategoriseres som en eventyrfilm.
      <br />
      <br />
      Filmen «Vicious Dogs» setter ut til å være eksemplet på hva som skjer når du adapterer en fortelling skrevet av et barn på en ikke-barnslig måte. Filmen er med andre ord ikke ment for barn, selv om den er skrevet av et. Fortellingen er visualisert ord for ord, og sparer ikke på detaljene. For eksempel, siden teksten er skrevet av et barn, så ignorerer teksten flere prinsipper man kan forvente å høre i en god tekst. Dette er ting som karakter-beskrivelser, mangel på forklaring av hvordan karakteren drar fra en plass til en annen, struktur og noen form for forsvarlig motivasjon innenfor karakterene. Resultatet er derfor en film som mangler alle disse prinsippene.
    </p>,
    <p>
      “Vicious Dogs” is a bizarre film about a boy on a trip through the forest and his encounters with the different creatures that live there. We are thrown into a world that is unpredictable, colourful, funny and merciless. The film is an adaptation of a story written by a 10-year-old, and combines digitally hand-animated 2D characters with modelled 3D backgrounds.
      <br />
      <br />
      We follow Per, a wrestler out for a run through the forest. The viewer never knows what is around the next corner for him: strange characters and changing surroundings he has to deal with. That makes it, in the end, an adventure film.
      <br />
      <br />
      “Vicious Dogs” sets out to show what happens when you adapt a story written by a child in a decidedly un-childlike way. In other words, the film is not meant for children, even though one wrote it. The story is visualised word for word and spares no details. Because it was written by a child, the text ignores many of the principles you would expect from a good story: character descriptions, any explanation of how the characters get from one place to another, structure, and any reasonable motivation for what the characters do. The result is a film that lacks all of these things.
    </p>)}>
         <div className="flex  mt-32 lg:px-0">
            <div className="max-w-sm">
            <img src={Progress_4} />
              <img src={Progress_2} />
              <img src={Progress_3} />

              <img src={Progress_1}  />
            </div>
          </div>

          <div className="flex flex-wrap justify-center mt-32 md:justify-between">

          </div>

    </PortfolioPage>

}

export default PortfolioCrispinGlover;
